import { render, staticRenderFns } from "./SpaceBG.vue?vue&type=template&id=4410d536&scoped=true&"
import script from "./SpaceBG.vue?vue&type=script&lang=js&"
export * from "./SpaceBG.vue?vue&type=script&lang=js&"
import style0 from "./SpaceBG.vue?vue&type=style&index=0&id=4410d536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4410d536",
  null
  
)

export default component.exports